import { useGetDownloadedSoundPackages } from '@bpm-web-app/swr-hooks';
import { convertSoundPackageToCarouselProps, createAppRoutes, DEFAULT_SOUNDS_LIMIT, soundPackageToCreatePlayable } from '@bpm-web-app/utils';
import { ComponentProps, useMemo } from 'react';
import { BreakpointView } from '../../shared/ui';
import { CreateCardCarousel } from '../../create-card-carousel/create-card-carousel';
import { useCreatePlayer } from '../../../../../utils/src/lib/create-player.context';
import { HorizontalTabs } from '../../shared/ui/horizontal-tabs/horizontal-tabs';

type CreateDownloadsProps = {
    mobileTabs: ComponentProps<typeof HorizontalTabs>['tabs'];
    listComponent: JSX.Element;
};

export const AccountsDownloadsCreate = ({ mobileTabs, listComponent }: CreateDownloadsProps) => {
    const { playDemo } = useCreatePlayer();

    const { data: soundPackages, isLoading } = useGetDownloadedSoundPackages(
        {
            limit: DEFAULT_SOUNDS_LIMIT,
        },
        true
    );

    const soundPackCarouselData = useMemo(() => soundPackages?.data.map((sound) => convertSoundPackageToCarouselProps(sound)), [soundPackages]);

    return (
        <BreakpointView
            desktopChildren={
                <>
                    <CreateCardCarousel
                        contentType="pack"
                        items={soundPackCarouselData}
                        cardSize="small"
                        carouselMorePath={createAppRoutes.accountDownloadPacks}
                        isLoading={isLoading}
                        carouselTitle="Packs"
                        carouselTitleCounter={`${soundPackCarouselData?.length}`}
                        onCardPlay={(id) => playDemo(soundPackageToCreatePlayable(soundPackages?.data.find((item) => item.id === id)))}
                        itemBasePath={createAppRoutes.packs}
                    />
                    {listComponent}
                </>
            }
            mobileChildren={<HorizontalTabs tabs={mobileTabs} />}
        />
    );
};
